'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { MainLayout } from './main-layout'
import { AuthGuard } from '../auth/auth-guard'

interface ConditionalLayoutProps {
  children: React.ReactNode
}

export function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname()
  const [hasTenant, setHasTenant] = useState<boolean | null>(null)

  // Check for tenant on mount
  useEffect(() => {
    const cookies = document.cookie.split(';')
    const tenantCookie = cookies.find(c => c.trim().startsWith('tenant-context='))
    setHasTenant(!!tenantCookie)
  }, [])

  // Public routes that don't require authentication
  const publicRoutes = ['/login', '/forgot-password', '/reset-password']
  const isPublicRoute = publicRoutes.includes(pathname)

  if (isPublicRoute) {
    // Render children without layout or auth guard for public routes
    return <>{children}</>
  }

  // If on homepage without tenant, render without layout (tenant selection page)
  if (pathname === '/' && hasTenant === false) {
    return <>{children}</>
  }

  // For protected routes, wrap in auth guard and main layout
  return (
    <AuthGuard>
      <MainLayout>
        {children}
      </MainLayout>
    </AuthGuard>
  )
}